import { createAction, createReducer } from '@reduxjs/toolkit';
import { combineReducers, type AnyAction } from 'redux';

import credentialsReducer, { initialState as credentialsInitialState } from './credentials';
import marketplacesReducer, { initialState as marketplacesInitialState } from './marketplaces';
import { type ApiSettingsState } from './types';

export const initialState: ApiSettingsState = {
  credentials: credentialsInitialState,
  marketplaces: marketplacesInitialState,
};

const combinedReducers = combineReducers({
  credentials: credentialsReducer,
  marketplaces: marketplacesReducer,
});

export const apiSettingsReset = createAction('apiSettings/reset');

const apiSettingsRootReducer = createReducer(initialState, builder => {
  builder.addCase(apiSettingsReset.type, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action: AnyAction) => {
  const newState = apiSettingsRootReducer(state, action);
  return combinedReducers(newState, action);
};
